<template>
  <div class="upload">
    <div class="title">先选择再添加（允许多个）</div>
    <el-select v-model="selectvalue" placeholder="请选择" class="select" @change="clickchange">
       <el-option
         v-for="item in erpuserneibulist" :key="item.Id" :label="item.Name" :value="item.Id">
       </el-option>
     </el-select>
    <div v-for="selectuser in selectmultiuser" :key="selectuser.Id">
      <el-input v-model="selectuser.Name" placeholder="请输入数量" style="width: 10%"></el-input>
      <el-button type="text" @click="clickdelete(selectuser)">删除</el-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      action: '',
      selectvalue: '',
      erpuserneibulist: [],
      selectmultiuser: []
    }
  },
  mounted () {
    this.apigeterpuserneibulist()
  },
  methods: {
    cleardata () {
      this.selectvalue = ''
      this.selectmultiuser = []
    },
    clickchange (rv) {
      this.clickadd()
    },
    clickadd () {
      var j = 0
      var len = this.erpuserneibulist.length
      for (j = 0; j < len; j++) {
        if (this.erpuserneibulist[j].Id === this.selectvalue) {
          var havefind = false
          for (var i = 0; i < this.selectmultiuser.length; i++) {
            if (this.selectmultiuser[i].Id === this.erpuserneibulist[j].Id) {
              havefind = true
            }
          }
          if (!havefind) {
            this.selectmultiuser.push(this.erpuserneibulist[j])
          }
        }
      }
      this.submitparent()
    },
    clickdelete (selectuser) {
      var buflist = []

      for (var j = 0, len = this.selectmultiuser.length; j < len; j++) {
        if (this.selectmultiuser[j].Id === selectuser.Id) {
        } else {
          buflist.push(this.selectmultiuser[j])
        }
      }
      this.selectmultiuser = buflist
      this.submitparent()
    },
    submitparent () {
      var s = ''
      for (var j = 0, len = this.selectmultiuser.length; j < len; j++) {
        s = s + '{' + this.selectmultiuser[j].Id + '}'
      }
      this.$emit('change', s)
    },
    apigeterpuserneibulist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Geterpuserneibulist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.erpuserneibulist = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-uploader{
  display: inline-block;
}
// /deep/ .el-upload {
//     border: 1px dashed #d9d9d9;
//     border-radius: 6px;
//     cursor: pointer;
//     position: relative;
//     overflow: hidden;
// }
// /deep/ .el-upload:hover {
//     border-color: #409EFF;
// }

.upload{
    // display: inline-block;
    margin-left: 0px;
}
</style>
